import React from 'react';
import './HalloweenCreatures.css';

// Fixed to the viewport edges so they never cover page content
const CREATURES = [
  { emoji: '🎃', className: 'pumpkin' },
  { emoji: '👻', className: 'ghost' },
  { emoji: '🦇', className: 'bat bat-left' },
  { emoji: '🦇', className: 'bat bat-right' },
];

const HalloweenCreatures = () => (
  <div className="halloween-creatures" aria-hidden="true">
    {CREATURES.map((c, i) => (
      <span key={i} className={`halloween-creature ${c.className}`}>
        {c.emoji}
      </span>
    ))}
  </div>
);

export default HalloweenCreatures;
